import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getLabStationDetail } from '../api/smartiLabApi';
import LabCard from '../components/LabCard';
import LabMetric from '../components/LabMetric';
import LabTable from '../components/LabTable';
import { useSmartiLabContext } from '../SmartiLabContext';

export default function StationDetailPage() {
  const { stationName } = useParams();
  const { sharedQuery } = useSmartiLabContext();
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    getLabStationDetail(stationName, sharedQuery).then(setDetail);
  }, [sharedQuery, stationName]);

  return (
    <div className="lab-page">
      <LabCard title={`Dettaglio stazione: ${stationName}`} description="Trend, step in fail, seriali coinvolti e file recenti per questa stazione.">
        <div className="lab-metric-grid">
          <LabMetric label="Test" value={detail?.summary?.totalTests ?? 0} />
          <LabMetric label="Conteggio fail" value={detail?.summary?.failCount ?? 0} />
          <LabMetric label="Conteggio pass" value={detail?.summary?.passCount ?? 0} />
          <LabMetric label="Fail rate" value={`${detail?.summary?.failRate ?? 0}%`} />
        </div>
      </LabCard>
      <div className="lab-grid two-col">
        <LabCard title="Trend giornaliero" description="Conteggi giornalieri di pass e fail per questa stazione.">
          <LabTable rows={detail?.trendByDay || []} columns={[
            { key: 'date', label: 'Data' },
            { key: 'totalTests', label: 'Test' },
            { key: 'passCount', label: 'Pass' },
            { key: 'failCount', label: 'Fail' },
          ]} />
        </LabCard>
        <LabCard title="Step più critici" description="Gli step in fail più frequenti osservati in questa stazione.">
          <LabTable rows={detail?.topFailingSteps || []} columns={[
            { key: 'step', label: 'Step' },
            { key: 'failCount', label: 'Conteggio fail' },
          ]} />
        </LabCard>
      </div>
      <LabCard title="Guida all’indagine" description="Suggerimenti di prossimi passi estratti dall’evidenza corrente di stazione.">
        <LabTable
          rows={(detail?.recommendations || []).map((value, index) => ({ id: index + 1, value }))}
          emptyTitle="Nessuna guida disponibile"
          emptyDescription="Questa stazione ha bisogno di più evidenza di fail o near-limit prima che Smarti Lab possa suggerire un percorso."
          columns={[{ key: 'value', label: 'Prossimo passo consigliato' }]}
        />
      </LabCard>
      <div className="lab-grid two-col">
        <LabCard title="Distribuzione versioni ATE" description="Quante volte compare ogni versione ATE in questa stazione.">
          <LabTable rows={detail?.ateVersionBreakdown || []} columns={[
            { key: 'value', label: 'Versione ATE' },
            { key: 'count', label: 'Conteggio' },
          ]} />
        </LabCard>
        <LabCard title="Distribuzione Testspec" description="Quante volte compare ogni Testspec in questa stazione.">
          <LabTable rows={detail?.testspecBreakdown || []} columns={[
            { key: 'value', label: 'Testspec' },
            { key: 'count', label: 'Conteggio' },
          ]} />
        </LabCard>
      </div>
      <LabCard title="Seriali ricorrenti" description="Seriali con eventi di fail ripetuti in questa stazione.">
        <LabTable rows={detail?.topRecurringSerials || []} columns={[
          { key: 'serialNumber', label: 'Seriale' },
          { key: 'failEvents', label: 'Eventi fail' },
        ]} />
      </LabCard>
      <LabCard title="File recenti" description="Ultimi file e seriali passati da questa stazione.">
        <LabTable rows={detail?.recentFiles || []} columns={[
          { key: 'testStarted', label: 'Avvio test' },
          { key: 'serialNumber', label: 'Seriale' },
          { key: 'filename', label: 'File' },
          { key: 'uutStatus', label: 'Stato' },
        ]} />
      </LabCard>
    </div>
  );
}
